/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { TextField, } from '@fluentui/react';
import { AUTH_CONFIG } from './auth0-variables';
import axios from 'axios';
import TwoSidedLayout from '../components/TwoSidedLayout';
import { useHistory, Link } from "react-router-dom";
import { WarningFilled } from "@fluentui/react-icons";
import Lottie from 'lottie-react-web'
import animation from './animation.json'

const error = (e) => css`
    .ms-TextField-fieldGroup {
        border-color: ${e ? '#ff1f1f' : '#D5DBE4'};
    }
    .ms-TextField-errorMessage{
    color:#ff1f1f;
        padding-top: 0;
    }
    `;
const container = () => css`
    p, button, button span,label{
        font-family: "proxima-nova", "Arial CE", Arial, sans-serif !important;
    }
    font-family: "proxima-nova", "Arial CE", Arial, sans-serif !important;
    `;

const warning = () => css`
    display: flex;
    align-items: flex-start;
    background: rgb(254, 247, 225);
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 12px 12px 12px 20px;
    max-width: 100%;
    width: 100%;
    font-family: "proxima-nova", "Arial CE", Arial, sans-serif;

    svg{
        font-size: 20px;
        color: rgb(214, 156, 0);
    }
    p{
        line-height: 18px;
        margin: 0;
        font-size: 13px;
        color: rgb(48, 54, 60);
    }
    `;
const lottie = () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    margin-top: 20px;
    `;
function PasswordReset(props) {
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(undefined);
    const [confirmPassword, setConfirmPassword] = useState();
    const [confirmPasswordError, setConfirmPasswordError] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState({header:'', body:''});
    const [showSuccess, setShowSuccess] = useState(false);
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get("token")
    const email = queryParams.get("email")
    const [loading, setLoading] = useState(false);

    // NEW: mobile detection
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        // Treat coarse pointers OR small widths as mobile
        const mql = window.matchMedia('(pointer:coarse), (max-width: 767px)');
        const check = () => setIsMobile(!!mql.matches);
        check();
        // Support older browsers
        if (mql.addEventListener) {
            mql.addEventListener('change', check);
            return () => mql.removeEventListener('change', check);
        } else {
            mql.addListener(check);
            return () => mql.removeListener(check);
        }
    }, []);


    const handleSubmit = (i, type, value) => {
        setLoading(true);
        var model = {
            Password: password,
            ConfirmPassword: confirmPassword,
            Email: email,
            Token: token
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/resetpassword", model)
            .then((response) => {
                setShowSuccess(true)
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.data === "Invalid token.") {
                    setErrorMessage({
                        header: 'This reset link is invalid',
                        body: 'Please request a new one and make sure you go through the process on the same device and browser.'
                    });
                } else {
                    setErrorMessage({
                        header: 'Invalid password.',
                        body: 'Please create a password with at least 8 characters, one lower case letter, one number and one special character.'
                    });
                }
            });
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(undefined)
    };

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
        setConfirmPasswordError(undefined)
    };

    const password_validate = () => {
        var re = {
            capital: /(?=.*[A-Z])/,
            length: /(?=.{7,40}$)/,
            specialChar: /[ -\/:-@\[-\`{-~]/,
            digit: /(?=.*[0-9])/,
        };
        return (
            re.capital.test(password) &&
            re.length.test(password) &&
            re.specialChar.test(password) &&
            re.digit.test(password)
        );
    };

    return (
        <TwoSidedLayout width={400}>
            <div className="height100 flexcolumn width100" style={{ maxWidth: '400px', margin: 'auto', height:'80%' }}>
            <div className=" login-page__form ">
                {!showSuccess && <>
                    <h2 className="head-30 mb10" >Set up your new password</h2>
                    <p className="mb35" style={{ color: '#68707b' }}>Make it one that you'll remember</p>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="mb10" css={error(passwordError)}>
                                <TextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    errorMessage={passwordError}
                                    id="password"
                                    label="Password"
                                    type="password"
                                    value={password}
                                    type="password"
                                    canRevealPassword
                                    onChange={handlePasswordChange}
                                    onBlur={(e) => {
                                        if (!password_validate()) {
                                            setErrorMessage({
                                                header: 'Password not strong enough.',
                                                body: 'Please create a password with at least 8 characters, one lower case letter, one number and one special character.'
                                            })
                                        }
                                    }}
                                />
                            </div>
                            <p className="secondary-small mb20" style={{ color: '#818b95' }}>
                                Your password must contain at least 8 characters, one lower case letter, one number and one special character.</p>
                            <div className="mb10" css={error(confirmPasswordError)}>
                                <TextField
                                    styles={{ fieldGroup: { height: '44px' }, field: { height: '42px' } }}
                                    errorMessage={confirmPasswordError}
                                    id="password"
                                    label="Confirm new password"
                                    type="password"
                                    value={confirmPassword}
                                    type="password"
                                    canRevealPassword
                                    onChange={handleConfirmPasswordChange}
                                />
                            </div>

                            {errorMessage.header && <div className="my10" css={warning}>
                                <div className="mr15"><WarningFilled /></div>
                                <div className="displayflex flexcolumn">
                                    <h5 className="head-xs mb5">{errorMessage.header}</h5>
                                    <p className="label-large">{errorMessage.body}</p>
                                </div>
                            </div>}
                            <div>
                                <PrimaryButton
                                    text={!loading ? "Change my password" : <Spinner size={SpinnerSize.small} />}
                                    disabled={!password_validate() || (password !== confirmPassword) || (!password)}
                                    onClick={handleSubmit}
                                    style={{ width: '100%' }}
                                    className="mt10 continue" />
                               
                            </div>
                        </div>
                    </form>
                </>}
                {showSuccess && <div className="flexcolumn aligncenter justifycenter">
                    
                    <div css={lottie}>
                        <Lottie
                            options={{
                                animationData: animation,
                                loop: false,
                            }}
                        />
                    </div>
                    <h2 className="head-30 mt20" >Password Changed!</h2>
                    <p className="mb35 mt5" style={{ color: '#68707b' }}>Your password has been changed successfully.</p>
                  
                   

                    {/* MOBILE-ONLY: show mobile download block */}
                    {isMobile && (
                        <div className="flexcolumn justifycenter show-mobile">
                            <h1 className="head-m" style={{ fontSize: 18 }}>Download our mobile app</h1>
                            <div className="flexcolumn justifycenter">
                                <a href="https://apps.apple.com/us/app/teamsly/id6575352008?platform=iphone">
                                    <img style={{ height: 50 }} src="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/66f4939584a817e010a2d5e7_app-store-small.avif" loading="lazy" alt="" />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.teamsly.teamsly&hl=en_US">
                                    <img style={{ height: 50 }} src="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/66f4943bb9181e7e43b3fa5b_google-play-small.avif" loading="lazy" alt="" />
                                </a>
                            </div>
                        </div>
                    )}

                    {/* DESKTOP/TABLET-ONLY: show Log in button */}
                    {!isMobile && (
                        <PrimaryButton
                            text={"Log in"}
                            onClick={() => history.push('/login')}
                            style={{ width: '100%' }}
                            className="mt10 continue"
                        />
                    )}

                </div>}
                </div>
            </div>
        </TwoSidedLayout>
    );
}

export default PasswordReset;